export class UserRoles {
    public static readonly ADMIN = 'Admin';
    public static readonly WORKSHOP = 'Workshop';
    public static readonly CUSTOMER_SERVICE = 'Customer Service';
    public static readonly STREET_TEAM = 'Street Team';
    public static readonly CUSTOMER = 'Customer';
    public static readonly TICKET_INTEGRATOR = 'TicketIntegrator';
}